import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { DownIcon } from 'foundations-assets/icons/components/DownIcon';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DropdownContext = /*#__PURE__*/createContext(null);
export const useDropdownState = () => {
  const state = useContext(DropdownContext);
  if (!state) throw new Error('Cannot access DropdownState without provider parent');
  return state;
};
export const MobileDropdown = ({
  children
}) => {
  const history = useHistory();
  const [show, setShow] = useState(false);
  const [drilldownKey, setDrilldownKey] = useState(null);
  const toggle = useCallback(() => {
    setShow(isShowing => !isShowing);
  }, []);
  const state = useMemo(() => ({
    show,
    toggle,
    drilldownKey,
    setDrilldownKey
  }), [drilldownKey, show, toggle]);
  useEffect(() => {
    return history.listen(() => {
      setShow(false);
      setDrilldownKey(null);
    });
  }, [history, setShow]);
  return /*#__PURE__*/_jsx(DropdownContext.Provider, {
    value: state,
    children: children
  });
};
export const MobileDropdownButton = ({
  'data-test-id': dataTestId,
  children,
  onClick
}) => {
  const {
    toggle
  } = useDropdownState();
  const handleClick = useCallback(e => {
    toggle();
    if (onClick) {
      onClick(e);
    }
  }, [onClick, toggle]);
  return /*#__PURE__*/_jsxs(Button, {
    "data-test-id": dataTestId,
    onClick: handleClick,
    use: "unstyled",
    children: [children, /*#__PURE__*/_jsx(IconHolder, {
      color: "icon-interactive-on-fill-default",
      icon: DownIcon,
      size: "100"
    })]
  });
};
export const MobileDropdownButtonItem = ({
  'data-test-id': dataTestId,
  children,
  onClick
}) => {
  const {
    toggle
  } = useDropdownState();
  const handleClick = useCallback(e => {
    toggle();
    if (onClick) {
      onClick(e);
    }
  }, [onClick, toggle]);
  return /*#__PURE__*/_jsx(Button, {
    "data-test-id": dataTestId,
    onClick: handleClick,
    responsive: false,
    use: "unstyled",
    children: children
  });
};
export const MobileDropdownLinkItem = ({
  'data-test-id': dataTestId,
  children,
  onClick,
  to
}) => {
  return /*#__PURE__*/_jsx(RouterButton, {
    "data-test-id": dataTestId,
    onClick: onClick,
    responsive: false,
    to: to,
    use: "unstyled",
    children: children
  });
};